// extracted by mini-css-extract-plugin
export default {"informationPopupSwiperContainer":"yQPha3tgYTl7Vqra3HZA","informationPopupSwiperSlide":"O1fHtSYZXXdTva3uoiKs"};